<template>
    <v-img v-if="dataProvider && dataProvider.imageSrc" :src="$icsilab.getUrlImage(dataProvider.imageSrc)" :height="dataProvider.height"></v-img>
    <fx-anomalie-composant v-else composant="fx-bandeau-image" propriete="imageSrc"/>
</template>
<script>
    export default {
        name: "fx-bandeau-image",
        props: {
            dataProvider: {
                type: Object,
                default: null
            }
        },
        methods: {
            f_click() {
            }
        },
    }
</script>
